import { useContext } from "react";
import { QuickFilterPortalContext, QuickFilterPortalContextType } from "../contexts/quickFilterPortalContext";

const useQuickFilterPortal = (): QuickFilterPortalContextType => {
	const context = useContext(QuickFilterPortalContext);

	if (!context) {
		throw new Error('useQuickFilterPortal must be used within a QuickFilterPortalProvider.');
	}

	return context;
};

export default useQuickFilterPortal;
